import { useEffect, useState } from "react";
import api, { fmtDate } from "@/lib/api";
import { TableToolbar, matches, exportRows, Empty } from "./shared";

const COLUMNS = [
  { label: "Date", value: (q) => fmtDate(q.created_at) },
  { label: "Name", value: "name" },
  { label: "Email", value: "email" },
  { label: "Phone", value: "phone" },
  { label: "Interested Plan", value: "plan_interest" },
  { label: "Message", value: "message" },
];

export const EnquiriesTab = () => {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => {
    api.get("/admin/enquiries").then((r) => setItems(r.data)).catch(() => {});
  }, []);
  const rows = items.filter((i) => matches(i, q));
  return (
    <div data-testid="admin-enquiries-tab">
      <TableToolbar title="Enquiries" count={rows.length} query={q} onQuery={setQ} placeholder="Search name, phone, plan…" testId="enquiries" onExport={() => exportRows("enquiries", COLUMNS, rows)} />
      <div className="border border-white/10">
        <div className="grid grid-cols-12 gap-4 px-6 py-4 border-b border-white/10 font-accent text-[10px] tracking-[0.2em] uppercase text-white/35">
          <span className="col-span-3">Name</span>
          <span className="col-span-3">Contact</span>
          <span className="col-span-2">Plan</span>
          <span className="col-span-4">Message</span>
        </div>
        {rows.map((e) => (
          <div key={e.id} className="grid grid-cols-12 gap-4 px-6 py-5 border-b border-white/10 last:border-0" data-testid={`enquiry-row-${e.id}`}>
            <div className="col-span-3">
              <p className="text-sm text-white">{e.name}</p>
              <p className="text-xs text-white/35 mt-1">{fmtDate(e.created_at)}</p>
            </div>
            <div className="col-span-3 text-xs text-white/60">
              <a href={`mailto:${e.email}`} className="hover:text-[#D4AF37] transition-colors">{e.email}</a>
              <p className="mt-1"><a href={`tel:${e.phone}`} className="hover:text-[#D4AF37] transition-colors">{e.phone}</a></p>
            </div>
            <span className="col-span-2 text-xs text-[#D4AF37]">{e.plan_interest || "—"}</span>
            <p className="col-span-4 text-xs text-white/50 leading-relaxed">{e.message}</p>
          </div>
        ))}
        {rows.length === 0 && <Empty testId="enquiries-empty" text={q ? "No enquiries match your search." : "No enquiries yet."} />}
      </div>
    </div>
  );
};
